export default "__VITE_ASSET__AXaCV8nH__"